import React from 'react';
import { Mail } from 'lucide-react';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#050505] text-white pt-24 px-6 md:px-12 flex flex-col items-center justify-center">
      <div className="max-w-xl w-full border border-white/10 rounded-2xl p-8 bg-black/40">
        <h1 className="text-4xl md:text-5xl font-black uppercase tracking-tighter mb-8">Contact</h1>
        <p className="text-zinc-500 mb-8">Une question ? Un problème logistique ? Notre équipe Festin est à votre écoute pour vous accompagner au mieux.</p>
        
        <div className="flex items-center space-x-4 bg-black/60 border border-white/10 p-6 rounded-xl">
          <Mail className="w-8 h-8 text-[#FF5E00]" />
          <div>
            <div className="text-[10px] font-mono text-zinc-500 uppercase tracking-widest mb-1">Email support</div>
            <a href="mailto:contact@festin.live" className="text-lg font-bold text-white hover:text-[#FF5E00] transition-colors">contact@festin.live</a>
          </div>
        </div>
      </div>
    </div>
  );
}
